import React from 'react';
import PropTypes from 'prop-types';
import { useFormState } from 'react-final-form';
import GiftaidPopupText from '../../../../../01_atoms/GiftaidPopupText';
import { CheckboxesField } from '../../../../../01_atoms/FormElements';
import PopupLink from '../../../../../02_molecules/PopupLink';
import FundraisingCosts from '../../../../../02_molecules/FundraisingCosts';
import TotalCost from '../../../../../02_molecules/TotalCost';
import { DEFAULT_COUNTRY_CODE } from '../../../../../../utils/constants';

import styles from './index.module.scss';
import programmeStyles from '../../../BBProgramme/index.module.scss';

const PayPalForm = ({
  paypalButton,
  showFundraisingCosts = false,
  fundraisingCostsTooltip = '',
}) => {
  const { values } = useFormState();

  return (
    <div className={styles['paypal-form']}>
      <div className={styles['paypal-form__container']}>
        <div className={styles['paypal-form__container-left']}>
          <div className={styles['paypal-form__title']}>PayPal</div>

          {DEFAULT_COUNTRY_CODE === 'GB' && (
            <div className={styles['paypal-form__gift-aid']}>
              <img src="/static/images/giftaid.png" alt="Giftaid" width={150} height={60} />
              <div className={styles['paypal-form__gift-aid-title']}>
                Increase the value of my donation by 25% at no extra cost
              </div>
              <CheckboxesField
                name="gift_aid"
                options={[
                  {
                    value: 'gift_aid',
                    label:
                      'I am a UK taxpayer and I would like Concern to reclaim the tax I have paid on this donation, any donation I have made in the previous four years, and any donations I may make in the future. The Gift Aid claimed will help fund Concern’s work to end extreme poverty.',
                  },
                ]}
                label=""
                withBackground
              />

              <div className={styles['paypal-form__gift-aid-info']}>
                <PopupLink className={programmeStyles['popup-programme']} linkText="More Info">
                  <GiftaidPopupText />
                </PopupLink>
              </div>
            </div>
          )}

          {showFundraisingCosts &&
            values.donation_type === 'single' &&
            values.amount.single > 0 && (
              // If you are changing the condition ^, make sure it is
              // consistent with isFundraisingCostsVisible() function.
              <>
                <div className={styles['paypal-form__description']}>
                  Do you want to cover the costs of this transaction?
                </div>
                <FundraisingCosts tooltipText={fundraisingCostsTooltip} />
              </>
            )}

          <TotalCost values={values} />

          {paypalButton}
        </div>
      </div>
    </div>
  );
};

PayPalForm.propTypes = {
  paypalButton: PropTypes.object.isRequired,
  showFundraisingCosts: PropTypes.bool,
  fundraisingCostsTooltip: PropTypes.string,
};

export default PayPalForm;
